export default __webpack_public_path__ + "static/media/Envelope.8960d4c8.svg";